import React from 'react'

const Dropdown = ({ children, active }) => {
  const showDropdown = active ? 'active' : 'hidd'
  return (
    <div className='nav-perfil__box'>
      <div className='nav-perfil__box__control'>
        {children}
      </div>
      <div className={`nav-perfil__box__control nav-perfil__box__control--mobile ${showDropdown}`}>
        {children}
        <div name='dropdown-grey' className='absolute pin w-full h-full bg-black hidd' style={{opacity: '0.5'}} />
      </div>
    </div>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Header/Dropdown.js